<template>
  <div class="col-md-12 form-base payment-product-item">
    <div class="row thumb-section">
      <div class="col-auto image">
        <b-img :src="imgUrl" alt="Center image"></b-img>
      </div>
      <div class="col description">
        <p class="title">{{ title }}</p>
        <p class="desc">{{ description }}</p>
      </div>
    </div>

    <div class="row price-section ">
      <div class="col total-desc">
        <span class="total-text"> {{ $t(LangConstants.total_text) }} </span>
        <span class="subscription-type"> ({{ $t(LangConstants.sparkfore_team) }}, {{ $t(LangConstants.payment_period_text) }}: {{ $t(subPeriod) }}) </span>
      </div>
      <div class="col-md-auto total-price">
        <span class=""> {{ total }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import "../../assets/scss/payment-product-item.scss";
import Constants from "../../constants/index";

export default {
  name: "payment-product-item",
  props: {
    title: {
      type: String,
      required: true,
      default: "Sparkfore Team",
    },
    imgUrl: {
      type: String,
      required: true,
      default: "https://img.favpng.com/8/1/9/square-euclidean-vector-rectangle-shape-png-favpng-yzRYNb4L5kLDkHW0eC2SSp5TG.jpg",
    },
    subPeriod: {
      type: String,
      required: true,
      default: "Monthly",
    },
    total: {
      type: String,
      required: true,
      default: "000.00 SEK",
    },
    description: {
      type: String,
      default: "Product Description goes here",
    },
  },

  computed: {
    LangConstants() {
      return Constants;
    },
  },
};
</script>
